import React from 'react';
import { Form, Card, Space, Switch, Radio, Input, Upload, Button, Typography } from 'antd';
import { VideoCameraOutlined, PlayCircleOutlined, UploadOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import SectionKicker from './SectionKicker';
import { brand } from '../../styles/theme';

const { Text } = Typography;

const destructiveStyle = {
  borderColor: brand.dangerBorder,
  color: brand.primary
};

const VideoSection = ({
  hasVideo,
  videoType,
  videoUrl,
  videoThumbnail,
  uploadingVideo,
  uploadingVideoThumb,
  onHasVideoChange,
  onVideoTypeChange,
  onVideoUrlChange,
  onVideoUpload,
  onVideoThumbnailUpload,
  onRemoveVideo,
  detectVideoType,
  renderVideoPreview
}) => {
  return (
    <div style={{ 
      marginBottom: 24, 
      paddingBottom: 16, 
      borderBottom: '2px solid #f0f0f0' 
    }}>
      <SectionKicker icon={VideoCameraOutlined}>Vídeo del Artículo</SectionKicker>

      <Form.Item
        label={
          <span style={{ 
            fontSize: '17px', 
            fontWeight: '600',
            color: '#262626',
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}>
            <VideoCameraOutlined />
            Video del artículo (opcional)
          </span>
        }
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          {/* Switch para habilitar video */}
          <div>
            <Switch
              checked={hasVideo}
              onChange={onHasVideoChange}
              checkedChildren="Con video"
              unCheckedChildren="Sin video"
            />
            {hasVideo && (
              <Text type="secondary" style={{ marginLeft: 12 }}>
                Este artículo incluirá un video
              </Text>
            )}
          </div>

          {hasVideo && (
            <Card size="small" style={{ backgroundColor: '#f8f9fa' }}>
              {/* Selector de tipo de video */}
              <div style={{ marginBottom: 16 }}>
                <Text strong>Tipo de video:</Text>
                <Radio.Group
                  value={videoType}
                  onChange={(e) => onVideoTypeChange(e.target.value)}
                  style={{ marginLeft: 12 }}
                >
                  <Radio.Button value="url">
                    <PlayCircleOutlined /> URL (YouTube/Vimeo)
                  </Radio.Button>
                  <Radio.Button value="upload">
                    <UploadOutlined /> Subir MP4
                  </Radio.Button>
                </Radio.Group>
              </div>

              {/* Campo URL o Upload según selección */}
              {videoType === 'url' ? (
                <div>
                  <Text strong>URL del video:</Text>
                  <Input
                    placeholder="Ej: https://www.youtube.com/watch?v=... o https://vimeo.com/..."
                    value={videoUrl}
                    onChange={(e) => onVideoUrlChange(e.target.value)}
                    style={{ marginTop: 8 }}
                    suffix={videoUrl && <PlayCircleOutlined style={{ color: '#52c41a' }} />}
                  />
                  <div style={{ marginTop: 4, fontSize: 12, color: '#666' }}>
                    Soporta URLs de YouTube y Vimeo. Se convertirá automáticamente a formato embed.
                  </div>
                </div>
              ) : (
                <div>
                  <Text strong>Subir archivo de video:</Text>
                  <div style={{ marginTop: 8 }}>
                    <Upload
                      name="video"
                      showUploadList={false}
                      beforeUpload={onVideoUpload}
                      accept="video/*"
                    >
                      <Button
                        icon={<UploadOutlined />}
                        loading={uploadingVideo}
                        className="editor-action-btn"
                      >
                        {videoUrl ? 'Cambiar vídeo' : 'Subir vídeo MP4'}
                      </Button>
                    </Upload>
                    <div style={{ marginTop: 4, fontSize: 12, color: '#666' }}>
                      Sin límite de tamaño. Formatos soportados: MP4, WebM, AVI
                    </div>
                  </div>
                </div>
              )}

              {/* Thumbnail del video */}
              {videoType === 'upload' && (
                <div style={{ marginTop: 16 }}>
                  <Text strong>Thumbnail del video (opcional):</Text>
                  <div style={{ marginTop: 4, marginBottom: 8, fontSize: 12, color: '#666' }}>
                    {videoUrl 
                      ? '✨ Se generó un thumbnail automáticamente. Puedes cambiarlo si lo deseas.' 
                      : 'Se generará automáticamente al subir el video.'}
                  </div>
                  <div style={{ marginTop: 8 }}>
                    <Upload
                      name="videoThumbnail"
                      listType="picture-card"
                      showUploadList={false}
                      beforeUpload={onVideoThumbnailUpload}
                      accept="image/*"
                    >
                      {videoThumbnail ? (
                        <img 
                          src={videoThumbnail} 
                          alt="video thumbnail" 
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                        />
                      ) : (
                        <div>
                          <PlusOutlined />
                          <div style={{ marginTop: 8, fontSize: 12 }}>Thumbnail</div>
                        </div>
                      )}
                    </Upload>
                    {videoThumbnail && (
                      <Button
                        danger
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => onRemoveVideo('thumbnail')}
                        style={{ ...destructiveStyle, marginTop: 8 }}
                      >
                        Eliminar thumbnail
                      </Button>
                    )}
                  </div>
                </div>
              )}

              {/* Vista previa del video */}
              {renderVideoPreview && renderVideoPreview()}

              {/* Botón para eliminar video */}
              <div style={{ marginTop: 16, textAlign: 'right' }}>
                <Button
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => onRemoveVideo('all')}
                  style={destructiveStyle}
                >
                  Eliminar vídeo del artículo
                </Button>
              </div>
            </Card>
          )}
        </Space>
      </Form.Item>
    </div>
  );
};

export default VideoSection;

